import { Text, Title } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";
import { TextButton } from "@src/appV2/redesign/components/TextButton";

import { type ReviewMediaType, type StepAction } from "../types";

export interface SelectReviewTypeStepProps {
  workplaceName: string;
  onAction: (action: StepAction) => void;
}

export function SelectReviewTypeStep(props: SelectReviewTypeStepProps) {
  const { workplaceName, onAction } = props;

  function handleSelectType(reviewType: ReviewMediaType) {
    onAction({
      type: "NEXT_STEP",
      data: { reviewType },
    });
  }

  function handleSkip() {
    onAction({ type: "SKIP_STEP" });
  }

  return (
    <>
      <DialogContent sx={{ paddingY: 2 }}>
        <Stack spacing={6}>
          <Stack spacing={1}>
            <Text variant="caption" color="text.secondary">
              {workplaceName.toUpperCase()}
            </Text>
            <Title variant="h3" component="h3">
              Want to go deeper?
            </Title>
            <Text variant="body2" color="text.secondary">
              Share your experience to help your peers make better decisions about where to work.
            </Text>
          </Stack>

          <Stack spacing={4}>
            <SelectableBox
              withCallToActionIcon
              variant="secondary"
              startIconType="pencil"
              sx={{ alignItems: "flex-start", textAlign: "left" }}
              onToggleSelect={() => {
                handleSelectType("WRITTEN");
              }}
            >
              <Stack spacing={2}>
                <Text bold variant="body1">
                  Write it out
                </Text>
                <Text variant="body2" color="text.secondary">
                  Type your experience
                </Text>
              </Stack>
            </SelectableBox>

            <SelectableBox
              withCallToActionIcon
              variant="secondary"
              startIconType="video-outlined"
              sx={{ alignItems: "flex-start", textAlign: "left" }}
              onToggleSelect={() => {
                handleSelectType("VIDEO");
              }}
            >
              <Stack spacing={2}>
                <Text bold variant="body1">
                  Record a video
                </Text>
                <Text variant="body2" color="text.secondary">
                  TikTok style
                </Text>
              </Stack>
            </SelectableBox>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <TextButton sx={{ alignSelf: "center" }} onClick={() => handleSkip()}>
          I&apos;m done for now
        </TextButton>
      </DialogFooter>
    </>
  );
}
